export const styles = {
  audienceName: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 24,
    lineHeight: '136%',
    color: '#23252F',
    paddingBottom: '10px',
  },
  infoAboutModal: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '146%',
    color: '#6E707A',
  },
};
